<script>
export default {
  name: "BroadcastGroupForm",

  props: {
    editing: Boolean,
    groupInit: Object
  },

  data() {
    return {
      loading: false,
      group_form: false,
      group: {
        name: '',
        members: []
      },
      delete_user_modal: false,
      search: '',
      selected: [],
      edit_table: null,
      headers: [
        { text: 'Name', value: 'first_name'},
        { text: 'Username', value: 'user_name'},
        { text: 'Email', value: 'email'}
      ]
    }
  },

  methods: {
    async createGroup() {
      if (this.$refs.group_form.validate()) {
        this.group.members = []
        this.selected.forEach(sel => this.group.members.push(sel._id))
        this.loading = !this.loading
        await this.$store.dispatch('CREATE_BROADCAST_GROUP', this.group)
        if (!this.$store.getters.error) {
          this.$emit('close')
        }
        this.loading = !this.loading
      }
    },

    async updateGroup() {
      if (this.$refs.group_form.validate()) {
        this.group.members = []
        this.selected.forEach(sel => this.group.members.push(sel._id))
        this.loading = !this.loading
        await this.$store.dispatch('UPDATE_BROADCAST_GROUP', this.group)
        if (!this.$store.getters.error) {
          this.$emit('close')
        }
        this.loading = !this.loading
      }
    }
  },

  computed: {
    users() {
      const users = (this.$store.getters.users || []).filter(user => {
        return user.user_type !== "GUEST"
      })
      return users
    },
    isLoading1() {
      return this.$store.getters.isLoading1
    }
  },

  watch: {
    users: function (v) { return v || [] },
    isLoading1(v) {
      return v
    }
  },

  created() {
    console.log(this.$props.groupInit)
    if (this.$props.groupInit) {
      this.selected = this.$props.groupInit.members
      this.group = this.$props.groupInit
    }
  }
}
</script>

<template>
  <v-container>
    <v-card>
      <v-card-title>New Broadcast Group</v-card-title>
      <v-form v-model="group_form" ref="group_form">
        <v-text-field
            v-model="group.name"
            placeholder="Group Name"
            :rules="[v => !!v || 'required']"
            class="ma-3"
            outlined
        />
        <v-data-table
            :headers="headers"
            :items="users"
            :search="search"
            v-model="selected"
            show-select
            :loading="$store.getters.isLoading1"
        >
          <template v-slot:top>
            <v-text-field
                v-model="search"
                label="Search User"
                style="width: 40%"
                class="mx-4"
            ></v-text-field>
          </template>
          <template v-slot:[`item.first_name`]="{ item }">
            {{ item.first_name }} {{ item.last_name }}
          </template>
          <template v-slot:[`item.last_logged_in`]="{ item }">
            {{ item.last_logged_in }}
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="$emit('close')">Cancel</v-btn>
          <v-btn @click="updateGroup" v-if="editing" :loading="loading" color="success">Edit Group</v-btn>
          <v-btn @click="createGroup" v-else :loading="loading" color="success">Create Group</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<style scoped>

</style>